module.exports = __webpack_public_path__ + "static/media/medalla_M.8db3c9f4.png";